import styled, { css } from "styled-components";
import { media } from "../../theme/theme";
import { V3HeadlineH5 } from "../Typography";

const BlockQuoteCSS = css`
    display: block;
    margin-block-start: 1em !important;
    margin-block-end: 1em !important;
    margin-inline-start: 40px !important;
    margin-inline-end: 40px !important;
    border-left: ${({ theme }) => theme ? `2px solid ${theme.colors.dodgerBlue}` : null} !important;
    margin-left: 10px!important;
    padding-left: 20px!important;
    font-size: 18px!important;
    line-height: 30px!important;
    font-family: "Lora", serif!important;
    color: #394555!important;
    margin-top: 36px!important;
    margin-bottom: 36px!important;
`;

export const V3PostAttachmentWrapper = styled.div`
    padding: 20px;
    border-radius: 6px;
    background: ${({ theme }) => theme ? theme.v3.colors.grey96 : null};
`;

export const V3MediaImageWrapper = styled.div`
    img {
        width: 100%;
        height: auto;
    }
`;

export const MediaImage = styled.img`
    width: 100%;
    height: auto;
`;

export const BlockQuote = styled.blockquote`
    ${BlockQuoteCSS}
`;


export const ArticleLink = styled.a`
    text-decoration: none;
`;


export const PostWrapper = styled.div`
    padding: 16px 24px 16px 24px;
    border: 1px solid ${({ theme }) => theme ? theme.v3.colors.grey88 : "black"};
    border-radius: 8px;
`;

export const ThreadContainer = styled.div`
    ${media.tablet} {
        padding-top: 55px;
    }
`;

export const ThreadWrapper = styled.div<{ isLast?: boolean }>`
    position: relative;
    margin-bottom: 0;
    
    ${media.tablet} {
        padding-left: 70px;
        margin-bottom: 80px;
    }

    &:before {
        ${media.tablet} {
            display: block;
            content: "";
            width: 1px;
            height: calc(100% + 48px);
            position: absolute;
            background: ${({ theme }) => theme ? theme.v3.colors.grey88 : "black"};
            left: 30px;
            top: -23px;
        }
    }

    &:after {
        ${media.tablet} {
            display: ${({ isLast }) => isLast ? "block" : "none"};
            width: 9px;
            height: 9px;
            border-radius: 50%;
            background: ${({ theme }) => theme ? theme.v3.colors.grey88 : "black"};
            position: absolute;
            bottom: -34px;
            left: 26px;
            content: "";
        }
    }
`;

export const ThreadIconCount = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 6px 8px 6px 8px;
   
    > div {
        display: inline-flex;

        &:first-child {
            margin-right: 5px;
        }
    }
`;

export const ThreadIconWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 35px 0;
    position: relative;
    width: auto;

    ${media.tablet} {
        margin: 0;
    }

    &:before {
        content: "";
        width: 1px;
        height: 35px;
        position: absolute;
        background: ${({ theme }) => theme ? theme.v3.colors.grey88 : "black"};
        left: 50%;
        top: 0;
        transform: translateY(-100%);

        ${media.tablet} {
           display: none;
        }
    }

    &:after {
        content: "";
        width: 1px;
        height: 35px;
        position: absolute;
        background: ${({ theme }) => theme ? theme.v3.colors.grey88 : "black"};
        left: 50%;
        bottom: 0;
        transform: translateY(100%);

        ${media.tablet} {
           display: none;
        }
    }

    > div {
        display: inline-block;
        border: 1px solid ${({ theme }) => theme ? theme.v3.colors.grey88 : "black"};
        border-radius: 6px;
    }

    svg {
        display: inline-flex;
    }
`;

export const TweeterProfileComponent = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    margin-bottom: 35px;

    ${media.tablet} {
        margin-bottom: 0;
        top: -10px;
        left: 9px;
    }

    &:after {
        content: "";
        width: 1px;
        height: 35px;
        position: absolute;
        background: ${({ theme }) => theme ? theme.v3.colors.grey88 : "black"};
        left: 50%;
        bottom: 0;
        transform: translateY(100%);

        ${media.tablet} {
           display: none;
        }
    }
`;

export const TweeterProfileAvatar = styled.img`
    width: 42px;
    height: 42px;
    background: ${({ theme }) => theme ? theme.v3.colors.grey88 : "black"};
    border-radius: 50%;
    margin-right: 12px;
`;

export const ThreadPositioner = styled.div`
    ${media.tablet} {
        position: absolute;
        top: -55px;
        left: 0;
    }
`;

export const ThreadHandler = styled(V3HeadlineH5)`
    color: ${({ theme }) => theme ? theme.v3.colors.grey48 : "black"};
    font-weight: 500;
    text-transform: uppercase;
    margin-left: 5px;
`;